import type { MenuType } from '@/modules/Customer/interface/Menu';
import type { IconsNames } from '@eqi-investimentos/icons/web';
import { salesforceOpportunityConfig } from '@/config/salesForce';

export const handleMenuItemClick = (
  url: string,
  hasAccessToken: boolean,
  sendClickEvent: (params: { label: string }) => void
) => {
  if (!hasAccessToken) {
    window.dispatchEvent(new Event('open-unauthenticated-modal'));
  }

  sendClickEvent({
    label: salesforceOpportunityConfig.sendClickEvent.sideMenu.label(url),
  });
};

export const calculateVisibleItems = (
  items: MenuType[],
  containerWidth: number,
  moreButtonWidth: number,
  itemRefs: Map<string, HTMLDivElement>
) => {
  let usedWidth = 0;
  const gapWidth = 4;

  const visible: MenuType[] = [];
  const overflow: MenuType[] = [];
  const urls: string[] = [];

  items.forEach((item) => {
    const element = itemRefs.get(item.name);
    if (!element) return;

    const width = element.offsetWidth + gapWidth;

    if (usedWidth + width + moreButtonWidth <= containerWidth) {
      visible.push(item);
      usedWidth += width;
    } else {
      overflow.push(item);
    }

    if (item.url) urls.push(item.url);
  });

  if (overflow.length > 1) {
    visible.push({
      name: 'Ver mais',
      iconName: 'Add' as IconsNames,
      submenu: overflow,
    });
  } else {
    visible.push(...overflow);
  }

  return {
    items: visible,
    urls,
  };
};
